import { render } from "./Milestone.vue?vue&type=template&id=3f3f4f1a"
import script from "./Milestone.vue?vue&type=script&lang=js"
export * from "./Milestone.vue?vue&type=script&lang=js"

import "./Milestone.vue?vue&type=style&index=0&id=3f3f4f1a&lang=scss"
script.render = render

export default script